// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"88da1858","455":"0fb36f36","977":"7fac1d97"}[chunkId] + ".chunk.js";
};